export const locales = [
    { code: 'en', label: 'ENG' },
    { code: 'uk', label: 'UA' },
    { code: 'ru', label: 'RU' },
];
